<button
  type="button"
  mat-stroked-button
  class="reschedule-trigger"
  (click)="togglePopover()"
  [glxyPopover]="taskReschedulePopover"
>
  <mat-icon>calendar_today</mat-icon>
  {{ 'TASK_QUEUE.ACTIONS.RESCHEDULE' | translate }}
</button>

<glxy-popover #taskReschedulePopover [isOpen]="(isOpen$ | async) === true" [positions]="[PopoverPositionBottom]">
  <glxy-popover-title>{{ 'TASK_QUEUE.RESCHEDULE_TASK' | translate }}</glxy-popover-title>

  <glxy-form-field
    bottomSpacing="small"
    [showLabel]="false"
    size="default"
    class="detail-form-field"
    [prefixIcon]="'alarm'"
  >
    <input matInput type="datetime-local" [formControl]="rescheduleFormControl" />
    <mat-datepicker></mat-datepicker>
  </glxy-form-field>

  <glxy-popover-actions>
    <button
      type="button"
      mat-flat-button
      color="primary"
      class="reschedule-confirm"
      (click)="handleRescheduleTaskClick()"
    >
      {{ 'ACTIONS.SAVE' | translate }}
    </button>
    <button type="button" mat-stroked-button (click)="closePopover()">{{ 'ACTIONS.CANCEL' | translate }}</button>
  </glxy-popover-actions>
</glxy-popover>
